module.exports = __webpack_public_path__ + "img/bg-type02-pc.cfc97606.png";